import { Injectable } from '@angular/core';
import { Orgimage } from '../model/orgimage';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@src/environments/environment';
import { Orgstyle } from '@src/app/helpers/dynamicstyle/model/orgstyle';
@Injectable({
  providedIn: 'root'
})
export class OrglogoService {

  orgUrl:string = environment.apiUrl+'/organization/';
  pi:Orgimage;
  constructor(private http:HttpClient) { }

  addorgImage(orgimage:Orgimage,imgtype:string):Observable<Orgimage>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    const databody = JSON.stringify(orgimage);
    //console.log('databody: '+databody);
    const postUrl = this.orgUrl+orgimage.organizationId+'/image/'+imgtype;
    //console.log('posturl: '+postUrl);
    
    return this.http.post<any>(postUrl,databody,httpOptions);
    
   
  }
  addorgImageFile(file:File,url:string):Observable<any>{
    const httpOptionsUpload = {
      headers: new HttpHeaders({
        'Content-Type': file.type || 'application/octet-stream',
      }),
      withCredentials: true,
    }
    return this.http.put(url,file,httpOptionsUpload);
    
    
  }
  getSignedUploadUrl(filename:string, organizationId:string):Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    const body = JSON.stringify({ Key: filename, kind: 'org', organizationId });
    return this.http.post<any>(environment.apiUrl+'/logostore/getsignedurl',body,httpOptions);
  }

  getorgImageUrl(file:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
      const body = '{"Key":"'+file+'"}';
      return this.http.post<any>(environment.apiUrl+'/docstore/getsignedgeturl',body,httpOptions);

   
  }
  getorgImageDB(orgId:string,type:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var urlCombo = `${this.orgUrl}`+orgId+'/image/'+type;
    return this.http.get<any>(urlCombo,httpOptions);
  }

  deleteorgImage(){
    //TODO
  }
  getOrgstyles(orgId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Orgstyle[]>(environment.apiUrl+'/organization/'+orgId+'/whitelabel/list',httpOptions);
  }
}